import { useMutation, useQueryClient } from 'react-query'

import { IImpactPeriodForm } from 'src/types'
import { impactPeriodService } from 'src/services/impact-period.service'

import { QUERY_KEYS } from 'src/constants'

export const useCreateImpactPeriod = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async (item: IImpactPeriodForm) => {
      return impactPeriodService.createImpactPeriod(item)
    },
    {
      onSuccess() {
        queryClient.invalidateQueries(QUERY_KEYS.IMPACT_PERIODS)
      },
    },
  )
}
